import { AggregateRoot, CommandHandlerFunction } from "@lookiero/messaging";
import { BookCheckoutBookingForCheckoutItem } from "../command/bookCheckoutBookingForCheckoutItem";
import { ReconciliateCheckoutBooking } from "../command/reconciliateCheckoutBooking";
import { checkoutBookingBooked } from "./checkoutBookingBooked";
import { checkoutBookingExpired } from "./checkoutBookingExpired";
import { checkoutBookingNotExpired } from "./checkoutBookingNotExpired";

interface CheckoutBooking extends AggregateRoot {
  readonly checkoutItemIds: string[];
  readonly isExpired: boolean;
}

const bookCheckoutBookingForCheckoutItemHandler: CommandHandlerFunction<
  BookCheckoutBookingForCheckoutItem,
  CheckoutBooking
> =
  () =>
  async ({ aggregateRoot, command }) => {
    const { aggregateId, checkoutItemId } = command;

    return {
      ...aggregateRoot,
      domainEvents: [checkoutBookingBooked({ aggregateId, checkoutItemId })],
    };
  };

const reconciliateCheckoutBookingHandler: CommandHandlerFunction<ReconciliateCheckoutBooking, CheckoutBooking> =
  () =>
  async ({ aggregateRoot, command }) => {
    const { aggregateId, isExpired } = aggregateRoot;
    const { checkoutId } = command;

    return {
      ...aggregateRoot,
      domainEvents: [
        isExpired ? checkoutBookingExpired({ aggregateId, checkoutId }) : checkoutBookingNotExpired({ aggregateId }),
      ],
    };
  };

export type { CheckoutBooking };
export { bookCheckoutBookingForCheckoutItemHandler, reconciliateCheckoutBookingHandler };
